// src/modules/Rostera/Data/DummyData.js

export const dummyStaff = [
  {
    id: '1',
    name: 'Sarah Johnson',
    email: 'sarah.johnson@company.com',
    department: 'Nursing',
    position: 'Senior Nurse',
    skills: ['ICU', 'Emergency', 'Pediatrics'],
    status: 'active',
  },
  {
    id: '2',
    name: 'Michael Chen',
    email: 'michael.chen@company.com',
    department: 'Nursing',
    position: 'Nurse',
    skills: ['General', 'Surgery'],
    status: 'active',
  },
  {
    id: '3',
    name: 'Emma Rodriguez',
    email: 'emma.rodriguez@company.com',
    department: 'Support',
    position: 'Care Assistant',
    skills: ['Patient Care', 'Administration'],
    status: 'active',
  },
  {
    id: '4',
    name: 'David Wilson',
    email: 'david.wilson@company.com',
    department: 'Nursing',
    position: 'Nurse Practitioner',
    skills: ['ICU', 'Critical Care', 'Emergency'],
    status: 'active',
  },
  {
    id: '5',
    name: 'Lisa Thompson',
    email: 'lisa.thompson@company.com',
    department: 'Support',
    position: 'Ward Assistant',
    skills: ['Patient Care', 'Cleaning'],
    status: 'benched',
  },
  {
    id: '6',
    name: 'James Miller',
    email: 'james.miller@company.com',
    department: 'Nursing',
    position: 'Senior Nurse',
    skills: ['Emergency', 'Trauma', 'ICU'],
    status: 'benched',
  },
];

export const dummyShifts = [
  {
    id: 'morning',
    name: 'Morning Shift',
    startTime: '06:00',
    endTime: '14:00',
    requiredStaff: 3,
    department: 'All',
    type: 'morning',
  },
  {
    id: 'afternoon',
    name: 'Afternoon Shift',
    startTime: '14:00',
    endTime: '22:00',
    requiredStaff: 2,
    department: 'All',
    type: 'afternoon',
  },
  {
    id: 'night',
    name: 'Night Shift',
    startTime: '22:00',
    endTime: '06:00',
    requiredStaff: 2,
    department: 'All',
    type: 'night',
  },
];

export const dummyLeaveRequests = [
  {
    id: '1',
    staffId: '1',
    type: 'planned',
    startDate: '2024-01-15',
    endDate: '2024-01-17',
    status: 'approved',
    reason: 'Vacation',
    submittedAt: '2024-01-01T10:00:00Z',
  },
  {
    id: '2',
    staffId: '2',
    type: 'sick',
    startDate: '2024-01-20',
    endDate: '2024-01-20',
    status: 'pending',
    reason: 'Flu symptoms',
    submittedAt: '2024-01-20T08:00:00Z',
  },
  {
    id: '3',
    staffId: '3',
    type: 'emergency',
    startDate: '2024-01-22',
    endDate: '2024-01-22',
    status: 'approved',
    reason: 'Family emergency',
    submittedAt: '2024-01-22T06:30:00Z',
  },
];
